module.exports = __webpack_public_path__ + "static/media/iconAdresse.3f458281.svg";